<template>
  <div class="container" >
    <template v-if="user">
      <img :src="user.profile_pic">
      <div>
        <p class="name" @click="go_to_respondent_page()">{{ user.uid }}</p>
        <p class="time" v-if="unix" >{{ date }} {{ time }}</p>
      </div>
      <a-tooltip>
        <template slot="title">{{ nps_score }}</template>
        <div class="nps-category" v-if="is_nps_survey && nps_score !== undefined && nps_score !== ''" :class="{ promoter: nps_score >= 9, passive: nps_score <= 8 && nps_score >= 7, detractor: nps_score <= 6 }"></div>
      </a-tooltip>
    </template>
  </div>
</template>

<script>

import moment from 'moment';

export default {
  name: 'userInfo',
  props: {
    uid: String,
    unix: Number,
    nps_override: Number
  },
  components: {},
  data() {
    return {
     visible: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.respondents[this.uid];
    },
    time() {
      return moment.unix(this.unix).format("h:mma");
    },
    date() {
      return moment.unix(this.unix).format("MMM Do");
    },
    nps_score() {
      if (this.nps_override !== null) {
        return this.nps_override;
      } else {
        return this.user.nps_score !== undefined ? this.user.nps_score : '';
      };
    },
    is_nps_survey() {
      return this.$store.state.surveys[this.$route.params.survey_index].nps;
    },
  },
  mounted() {
    // if (!this.$store.state.respondents[this.uid]) {
    //   this.$store.dispatch('setRespondent', this.uid);
    // };
  },
  methods: {
    go_to_respondent_page() {
      this.$router.push({ name: 'respondent', params: { uid: this.uid } })
      analytics.track('User Name Clicked');
    },
  }
}
</script>

<style scoped lang="scss">
.container{
  margin-bottom: 8px;
  font-family: "Montserrat", sans-serif;
  width: 100%;
  height: 59px;
  & > * {
    display: inline-block;
    vertical-align: top;
  }
  img{
    object-fit: cover;
    width: 48px;
    height: 48px;
    border-radius: 4px;
    margin-right: 12px;
  }
}


.name,
.time{
  color: #0D303F;
  font-weight: 600;
}

.name{
  color: #0D303F;
  font-size: 14px;
  max-width: 145px;
  margin-top: 2px;
  margin-bottom: 4px;
  overflow: auto;
  text-overflow: ellipsis;
  &:hover{
    cursor: pointer;
  }
}

.time{
  font-size: 12px;
}

.nps-category{
  width: 25px;
  height: 25px;
  float: right;
  margin-top: 10px;
  background-color: transparent;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  &.promoter{
    background-image: url("../../../assets/icons/nps-promoter-icon.svg");
  }
  &.passive{
    background-image: url("../../../assets/icons/nps-passive-icon.svg");
  }
  &.detractor{
    background-image: url("../../../assets/icons/nps-detractor-icon.svg");
  }
}

.modal-pic{
  width: 100%;
}


// Ipad Portrait
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
}

</style>
